import {Modal} from 'react-bootstrap';
import React, {useState} from 'react';
import { adminService } from '../../Services/adminService';
import toast from 'react-hot-toast';

const RolesEdit = (props) => {
    const initialValues = {
        name: '',
        description: ''
    };
    const [values, setValues] = useState(initialValues);

    const handleInputChange = (event) => {
        setValues({
          ...values,
          [event.target.name]: event.target.value
        });
    };

    const save = () => {
        if(!validateFields())
            return;

        const role = {name: values.name, description: values.description};
        adminService.addRole(role)
        .then(() => {
            props.refresh();
            props.setShowModal(false);
            toast.success("Role has been successfully added");
        }).catch((e) => {
            console.log(e);
            toast.error("Unable to update the roles. Error: " + e);
        });
    }

    const validateFields = () => {
        if(values.name.trim() == "")
        {
            toast.error("Please enter Name");
            return false;
        }
        if(values.description.trim() == "") {
            toast.error("Please enter Description");
            return false;
        }
        return true;
    }

    return (
        <>
            <Modal
                show={() => props.setShowModal(true)}
                onHide={() => props.setShowModal(false)}
                backdrop="static"
                keyboard={false}
                dialogClassName="modal-dialog"
                className="modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h5>Add New Role</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="form-label" htmlFor="Name">Name <span className="required">*</span></label>
                                <input type="text" className="form-control" id="name" name="name" value={values.name} onChange={(e) => handleInputChange(e)}/>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                            <label className="form-label" htmlFor="Description">Description <span className="required">*</span></label>
                                <input type="text" className="form-control" id="Description" name="description" value={values.description} onChange={(e) => handleInputChange(e)} />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-outline" onClick={() => props.setShowModal(false)}>CLOSE</button>
                    <button type="button" className="btn btn-primary" onClick={() => save()}>SUBMIT</button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default RolesEdit;